import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'collegeevents.filters.create.header',
    defaultMessage: 'Create Filter',
  },
  errorUniqueName: {
    id: 'collegeevents.filters.create.error.uniqueName',
    defaultMessage: 'Filter name should be unique.',
  },
  incorrectPostalCode: {
    id: 'collegeevents.filters.create.error.incorrectPostalCode',
    defaultMessage: 'Postal code is not a valid US postal code.',
  },
  saveError: {
    id: 'collegeevents.filters.create.save-error',
    defaultMessage: 'There was an error while trying to save your changes.',
  },
  successTitle: {
    id: 'collegeevents.filters.create.success-title',
    defaultMessage: 'Filter created',
  },
  successDescription: {
    id: 'collegeevents.filters.create.success-description',
    defaultMessage: 'Your new filter was successfully created!',
  },
});

export default messages;
